module.exports=[
  {
     id:1,
     parentid:'0',
     path:'/home',
     label:'控制面板',
     name:'home',
     icon:'el-icon-s-home'
    },
    {
      id:2,
      parentid:'0',
      path:"archive",
      label:'文档',
      name:'archive',
      icon:'el-icon-document',
     },
    {
     id:3,
     parentid:'0',
     path:"/table",
     label:'基础表格',
     name:'tab',
     icon:'el-icon-s-tools',
    },
    {
     id:4,
     parentid:'0',
     path:"/tabs",
     label:'tab选项卡',
     icon:'el-icon-menu',
    },
    {
     id:5,
     parentid:'0',
     path:"表单相关",
     label:'表单相关',
     icon:'el-icon-s-order',
     children: [
      {
       id:6,
       parentid:'5',
       path:'/from',
       label:'基础表单',
       name:'from',
       icon:'el-icon-tickets'
      },
      {
       id:7,
       parentid:'5',
       path:'/upload',
       label:'文件上传',
       name:'upload',
       icon:'el-icon-upload'
      }
    ]
    },
    {
     id:8,
     parentid:'0',
     path:"系统管理",
     label:'系统管理',
     icon:'el-icon-s-order',
     children: [
      {
       id:9,
       parentid:'8',
       path:'/System/MenuSystem',
       label:'菜单管理',
       name:'MenuSystem',
       icon:'el-icon-tickets'
      },
      {
       id:10,
       parentid:'8',
       path:'/System/RoleSystem',
       label:'角色管理',
       name:'upload',
       icon:'el-icon-upload'
      }
    ]
    }
]






// WEBPACK FOOTER //
// ./src/router/config.js